module.exports = __webpack_public_path__ + "img/stars_t.f023cb3f.png";